module.exports = __webpack_public_path__ + "static/media/Restart_AERO.41f840b6.svg";